import Vue from 'vue'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'

export default Vue.extend({
  components: {
    AscAutocompleteSelector,
  },

  data: function () {
    return {
      currentValue: [],
      items: [],
      disabled: true,
      sortItems: true,
    }
  },

  watch: {
    currentValue(newValue) {
      this.currentValue = newValue
      const valueToUse =
        this.currentValue.length === 0 ? null : this.currentValue
      const strValueToUse = valueToUse ? valueToUse.toString() : null
      this.params.parentFilterInstance(function (instance) {
        instance.onFloatingFilterChanged('autocomplete', strValueToUse)
      })
    },
  },

  beforeMount() {
    if (this.params.ids && this.params.ids.length > 0) {
      this.currentValue = this.params.ids
    } else if (this.params.ids.length === 0) {
      this.currentValue = this.params.items?.map(x => x.text)
    }
    if (this.params.items) {
      this.items = this.params.items
      this.disabled = this.params.items.length === 0
    }
    if (this.params.suppressDefaultSort) {
      this.sortItems = false
    }
  },

  methods: {
    //This is required dont remove
    onParentModelChanged() {},
  },

  template: `<div style="width:100%;"><asc-autocomplete-selector v-model="currentValue" :items="items" label="Features" componentType="multiple" float-filter use-strings :disabled="disabled" :sort-items="sortItems"></asc-autocomplete-selector></div>`,
})
